// extracted by mini-css-extract-plugin
export default {"marker":"clinicMap_marker__M88uA","mapWrap":"clinicMap_mapWrap__pjxQQ","mapWalkIns":"clinicMap_mapWalkIns__wVgBM"};